import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../../../app/store";
import CloseButton from "../../../components/shared-components/CloseButton";
import { PlayerMode, selectPlayer } from "../../../features/player/playerSlice";
import {
  selectTheme,
  showFooter,
  ThemeMode,
  themeSlice,
} from "../../../features/theme/themeSlice";
import FirstFooterLinks from "./FirstFooterLinks";
import HeaderLinks from "./HeaderLinks";
type FooterComponentProps = {
  onClose?: () => void;
  onOpen?: () => void;
  visible?: boolean;
};

const FooterComponent = ({
  onClose,
  onOpen,
  visible = true,
}: FooterComponentProps) => {
  const [width, setWidth] = useState<number>(window.innerWidth);
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const [playPgVirtual, setPlayPgVirtual] = useState<boolean>(false);
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const dispatch = useDispatch();
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  const location = useLocation();

  const [isVisible, setIsVisible] = useState(visible);
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  /*
  useEffect(() => {
    setPlayPgVirtual(location.pathname.indexOf("playpgvirtual") > -1);
  }, [location]);
**/
  return isVisible || theme.isMobile ? (
    <>
      {!theme.isMobile && !playPgVirtual && (
        <FirstFooterLinks
          onClose={() => {
            onClose && onClose();
            setIsVisible(false);
          }}
        />
      )}
      <div className="footer-content">
        {/* <div>
					<img src="/images/ams-footer.png" style={{ height: '20px', margin: '5px' }} />
				</div> */}
        <p>
          <FormattedMessage id="footer.pgcompany" />
        </p>
        <div>
          <img
            src="/images/sistemi-pagamento.png"
            style={{ height: "20px" }}
            alt="sistemi di pagamento"
          />
        </div>
        {/* {!theme.isMobile && (
          <CloseButton
            onClose={() => {
              onClose && onClose();
              setIsVisible(false);
            }}
          />
        )} */}
      </div>
    </>
  ) : playPgVirtual ? (
    <div
        className="footer-links-minified pointer"
        onClick={() => {
          if (playPgVirtual) {
            setIsVisible(true);
            dispatch(showFooter(true));
            onOpen && onOpen();
          }
        }}
      >
        
        <FontAwesomeIcon icon={faChevronUp} />
      </div>
  ) : (
    theme.mode !== ThemeMode.KIOSK &&
    !theme.isTablet && (
      <div
        className="footer-links-minified pointer"
        onClick={() => {
          if (!playPgVirtual) {
            setIsVisible(true);
            dispatch(showFooter(true));
            onOpen && onOpen();
          }
        }}
      >
        {/* <HeaderLinks
					menuInverse
					onUpChevron={() => {
						if (!playPgVirtual) {
							setIsVisible(true);
							dispatch(showFooter(true));
							onOpen && onOpen();
						}
					}}
				/> */}
        <FontAwesomeIcon icon={faChevronUp} />
      </div>
    )
  );
};

export default FooterComponent;
